import {Injectable} from '@angular/core';
import {OAuthResourceServerErrorHandler, OAuthStorage} from 'angular-oauth2-oidc';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class OAuthInterceptor implements HttpInterceptor {

  constructor(
    private authStorage: OAuthStorage,
    private errorHandler: OAuthResourceServerErrorHandler,
  ) {
  }

  private checkUrl(url: string): boolean {
    return url.startsWith(environment.apiBasepoint);
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const url = req.url.toLowerCase();


    if (!this.checkUrl(url)) {
      return next.handle(req);
    }


    const token = this.authStorage.getItem('access_token');
    const header = 'Bearer ' + token;

    const headers = req.headers
      .set('Authorization', header);

    req = req.clone({ headers: headers });
    return next.handle(req).pipe(
      catchError(
        err => this.errorHandler.handleError(err)
      )
    );

  }
}
